import Vue from 'vue'
import Router from 'vue-router'
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router)
import UserLayout from '@/layouts/UserLayout'

// 路由模块
import activitiesRouter from '@/router/modules/activities_router'
import productsRouter from '@/router/modules/products_router'
import chargingPackagesRouter from '@/router/modules/charging_packages_router'
import evChargingStationsRouter from '@/router/modules/ev_charging_stations_router'
import refundTasksRouter from '@/router/modules/refund_tasks_router'
import evChargingStationCommentsRouter from '@/router/modules/ev_charging_station_comments_router'
import parkingFeesRouter from '@/router/modules/parking_fees_router'
import spUsersRouter from '@/router/modules/sp_users_router'
import PostsRouter from '@/router/modules/posts_router'
import StationActivitiesRouter from '@/router/modules/station_activities_router'
import OrdersRouter from '@/router/modules/orders_router'
import equipmentsRouter from '@/router/modules/equipments_router'

const router = new Router({
  // history 需要nginx配置: https://router.vuejs.org/zh/guide/essentials/history-mode.html#后端配置例子
  mode: 'history',
  routes: [
    // 欢迎页（登录后的主页）
    {
      path: '/',
      component: UserLayout,
      redirect: '/welcome',
      children: [
        {
          path: 'welcome',
          component: () => import('@/views/Welcome')
        }
      ]
    },
    {
      path: '/wechat_entrypoint',
      component: () => import('@/views/pages/WechatEntrypoint')
    },
    {
      path: '/charging_app_store',
      component: () => import('@/views/pages/ChargingAppStore')
    },
    {
      path: '/app_store_guide',
      component: () => import('@/views/pages/AppStoreGuide')
    },
    {
      path: '/android_store_guide',
      component: () => import('@/views/pages/AndroidStoreGuide')
    },
    {
      path: '/miniprogram_guide',
      component: () => import('@/views/pages/MiniprogramGuide')
    },
    {
      path: '/app_entrypoint',
      component: () => import('@/views/pages/AppEntrypoint')
    },
    {
      path: '/sdk',
      component: () => import('@/views/thirdparty/Sdk.vue')
    },
    {
      path: '/orders/:id/idle_fee_relief',
      component: () => import('@/views/pages/IdleFeeBillRelief.vue')
    },
    // 公共页面
    {
      path: '/404',
      name: '404',
      component: () => import('@/views/commons/NotFound')
    },
    // 401未认证
    {
      path: '/unauthorized',
      name: 'unauthorized',
      component: () => import('@/views/commons/Unauthorized')
    },
    // 其它页面的路由
    activitiesRouter,
    productsRouter,
    chargingPackagesRouter,
    evChargingStationsRouter,
    refundTasksRouter,
    evChargingStationCommentsRouter,
    parkingFeesRouter,
    spUsersRouter,
    PostsRouter,
    StationActivitiesRouter,
    OrdersRouter,
    equipmentsRouter
    // 路由找不到时，返回到404
    // {
    //   path: '*',
    //   redirect: '/404'
    // }
  ]
})
/* 路由发生变化修改页面title */
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
export default router
